export const TABLEAU_DE_BORD = {
  listeRecom: {
    title: 'Mes dernières recommandations',
    column: {
      client: 'Client',
      date: 'Date de création',
      commercial: 'Commercial',
      montant: 'Montant',
      telecharger: 'Télécharger',
      modifier: 'Modifier',
      copier: 'Copier',
      ouvrir: 'Ouvrir',
      supprimer: 'Supprimer',
      archiver: 'Archiver',
      desarchiver: 'Désarchiver',
      devis: 'Devis',
      societe: 'Société',
      dateModif: 'Date de modification',
      devisAchat: 'Devis d’achat',
      portail: 'Portail',
    },
    actionGroupe: {
      titre: 'Action groupée',
      btnAppliquer: 'Appliquer',
      afficherPortail: 'Afficher sur le portail',
      masquerPortail: 'Masquer du portail',
    },
    copiePdv: {
      annuler: 'Conserver le point de vente',
      copier: 'Copier',
      reco: 'Recommandation',
      actuel: 'Point de vente actuel',
      nouveau: 'Nouveau point de vente',
      pdv: 'Point de vente',
      enseigne: 'Enseigne',
      aucunPdv: 'Aucun point de vente sélectionné',
    },
    empty: 'Aucune information n’a été trouvée',
    libelPerPage: 'Résultat par page :',
  },
  titlePage: 'Tableau de bord',
  titlePageListeRecommendation: 'Liste des recommandations',
  createRecommandation: 'Créer une recommandation',
  nameButtonInfoFact: 'Factures impayées',
  supprimerLaSelection: 'Supprimer la selection',
  afficherRecomArchivees: 'N\'afficher que les recommandations archivées',
  masquerRecomArchivees: 'Masquer les recommandations archivées',
  afficherRecomCommandees: 'Afficher les recommandations commandées',
  masquerRecomCommandees: 'Masquer les recommandations commandées',
};
